export default __webpack_public_path__ + "img/love.ececd129.svg";